import styled from '@emotion/styled';

export const Button = styled.button`
  height: auto;
  ${({ theme }) => theme.media.mobile} {
    height: 100%;
  }

  &::before {
    display: none;
    z-index: 100000000;
    content: '';
  }
`;

export const Slide = styled.div`
  width: 100%;
  padding: 30px 0;
  display: flex;
  flex-direction: row;

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
  }

  justify-content: space-between;
  align-items: center;
  margin-left: 20px;

  @media (max-width: 700px) {
    flex-direction: column;
  }
`;

export const PrevArrow = styled.div`
  border: 1px solid #dbdbdb;
  box-shadow: ${({ theme }) => theme.shadows.db1};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -200%;
  left: auto;
  margin-left: 0;

  ${({ theme }) => theme.media.mobile} {
    top: 100%;
    left: 10px;
  }
  ${({ theme }) => theme.media.tablet} {
    margin-left: -30px;
  }

  background: ${({ theme }) => theme.colors.white};
  transform: rotate(180deg);

  @media (max-width: 700px) {
    top: 95%;
  }
`;

export const NextArrow = styled.div`
  border: 1px solid #dbdbdb;
  box-shadow: ${({ theme }) => theme.shadows.db1};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  background: ${({ theme }) => theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  position: absolute;
  top: -200%;
  right: auto;

  ${({ theme }) => theme.media.mobile} {
    top: 100%;
    right: 10px;
  }

  @media (max-width: 700px) {
    top: 95%;
  }
`;

export const SliderWrapper = styled.div`
  & * {
    outline: none;
  }
  & .slick-dots li button:before {
    content: '';
  }

  & .slick-dots li button {
    position: absolute;
    background: ${({ theme }) => theme.colors.gray7};
    border: 1px solid white;
    width: 0.5rem;
    border-radius: 50%;
    height: 0.5rem;
  }

  & .slick-dots li.slick-active button {
    background: ${({ theme }) => theme.colors.pink};
  }
`;

export const ImgContainer = styled.div`
  width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 1.5rem;
  min-width: 200px;

  @media (max-width: 700px) {
    margin-bottom: 2rem;
  }

  img {
    margin-bottom: 1rem;
  }
`;

export const TextContainer = styled.div`
  width: 70%;
  display: flex;
  align-items: center;
`;
